export default __webpack_public_path__ + "static/media/sliderImg6.18ddc490.jpg";